module.exports = __webpack_public_path__ + "media/newstyle/images/70-mil-authors-es-bb070646892906073b9f86e8ee3276c5.svg";